// let base_url =
  // "http://ec2-3-16-163-41.us-east-2.compute.amazonaws.com/api/v1/";
// let base_url ="http://ec2-18-188-76-114.us-east-2.compute.amazonaws.com/api/v1/";

let base_url = "https://hjb-api-9948cd9b7682.herokuapp.com/v1/";
// let base_url = "http://localhost:3005/v1/";
export { base_url };
